import "../../index.css";
import {
  DASHBOARD_SCREEN_ROUTE,
  MANUFACTURER_DASHBOARD_SCREEN_ROUTE,
  NEWSALE_DASHBOARD_SCREEN_ROUTE,
  SALESHISTORY_DASHBOARD_SCREEN_ROUTE,
  BATCH_DASHBOARD_SCREEN_ROUTE,
  PURCHASES_DASHBOARD_SCREEN_ROUTE,
  MEDICINES_DASHBOARD_SCREEN_ROUTE,
  SUPPLIER_DASHBOARD_SCREEN_ROUTE,
  CATEGORY_DASHBOARD_SCREEN_ROUTE,
  MEDICINEFORMULA_DASHBOARD_SCREEN_ROUTE,
  STAFFMANAGEMENT_DASHBOARD_SCREEN_ROUTE,
  GETTECHINAL_DASHBOARD_SCREEN_ROUTE,
  RETURNITEM_DASHBOARD_SCREEN_ROUTE,
  RETURNHISTORY_DASHBOARD_SCREEN_ROUTE,
  NONMEDICINES_DASHBOARD_SCREEN_ROUTE,
  SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE,
  CHANGE_PASSWORD_SCREEN_ROUTE,
  RETURN_POLICY_SCREEN_ROUTE,
  EXPENSE_SCREEN_ROUTE,
  EXPENSE_CATEGORY_SCREEN_ROUTE,
  ORDER_PURCHASE_SCREEN_ROUTE,
  SHELF_DASHBOARD_SCREEN_ROUTE,
  PRODUCTSALESHISTORY_DASHBOARD_SCREEN_ROUTE,
  CUSTOMER_HISTORY_SCREEN_ROUTE
} from "../../routes";
import InventoryIcon from "../IconComp/inventoryIcon";
import DashboardIcon from "../IconComp/dashboardIcon";
import SalesIcon from "../IconComp/salesIcon";
import UserManagementIcon from "../IconComp/usermanagementIcon";
import ArrowDownIcon from "../IconComp/arrowDownIcon";
import GetTechnicalIcon from "../IconComp/getTechnicalIcon";
import ClinicIcon from "../IconComp/clinicIcon";
import React from "react";
import ArrowUpIcon from "../IconComp/arrowUpIcon";
import StaffmanagementIcon from "../IconComp/staffmanagementIcon";
import ShiftManagementIcon from "../IconComp/shiftManagement";
import DailyExpenseIcon from "../IconComp/dailyExpenseIcon";
import NewSaleIcon from "../IconComp/NewSaleIcon";
import ReturnItemsIcon from "../IconComp/ReturnItemsIcon";
import ReturnHistoryIcon from "../IconComp/ReturnHistoryIcon";
import SalesHistoryIcon from "../IconComp/SalesHistoryIcon";
import ProductSalesHistoryIcon from "../IconComp/ProductSalesHistoryIcon";
import BatchIcon from "../IconComp/batchIcon";
import OrderPurchaseIcon from "../IconComp/OrderPurchaseIcon";
import MedicalProductsIcon from "../IconComp/MedicalProductsIcon";
import SupplierIcon from "../IconComp/SupplierIcon";
import CategoryIcon from "../IconComp/categoryIcon";
import MedicineFormulaIcon from "../IconComp/MedicineFormulaIcon";
import ManufacturerIcon from "../IconComp/ManufacturerIcon";
import StockPurchaseIcon from "../IconComp/StockPurchaseIcon";
import ShelfIcon from "../IconComp/ShelfIcon";
import ExpenseIcon from "../IconComp/expenseIcon";
import ExpenseCategoryIcon from "../IconComp/ExpenseCategoryIcon";
import ChangePasswordIcon from "../IconComp/ChangePasswordIcon";
import ReturnPolicyIcon from "../IconComp/ReturnPolicyIcon";
export const SidebarItems = [
  {
    id: 1,
    href: DASHBOARD_SCREEN_ROUTE,
    icon: <DashboardIcon />,
    title: "Dashboard",
  },
  {
    id: 2,
    title: "Sales",
    icon: <SalesIcon />,
    // href: NEWSALE_DASHBOARD_SCREEN_ROUTE,
    icon2: <ArrowUpIcon />,
    icon3: <ArrowDownIcon />,
    subItems: [
      {
        id: 3,
        href: NEWSALE_DASHBOARD_SCREEN_ROUTE,
        icon: <NewSaleIcon />,
        title: "New Sale",
      },
      {
        id: 4,
        href: RETURNITEM_DASHBOARD_SCREEN_ROUTE,
        icon: <ReturnItemsIcon />,
        title: "Return Item",
      },
      {
        id: 5,
        href: SALESHISTORY_DASHBOARD_SCREEN_ROUTE,
        icon: <SalesHistoryIcon />,
        title: "Sales History",
      },
      {
        id: 5,
        href: RETURNHISTORY_DASHBOARD_SCREEN_ROUTE,
        icon: <ReturnHistoryIcon />,
        title: "Return History",
      },
      {
        id: 15,
        href: PRODUCTSALESHISTORY_DASHBOARD_SCREEN_ROUTE,
        icon: <ProductSalesHistoryIcon />,
        title: "Product Sales History",
      },
      {
        id: 16,
        href: CUSTOMER_HISTORY_SCREEN_ROUTE,
        icon: <ProductSalesHistoryIcon />,
        title: "Customer History",
      },
    ],
  },

  {
    id: 6,
    title: "Inventory",
    icon: <InventoryIcon />,
    href: MANUFACTURER_DASHBOARD_SCREEN_ROUTE,
    icon2: <ArrowUpIcon />,
    icon3: <ArrowDownIcon />,
    subItems: [
      {
        id: 7,
        href: BATCH_DASHBOARD_SCREEN_ROUTE,
        icon: <BatchIcon />,
        title: "Batch",
      },
      {
        id: 8,
        href: ORDER_PURCHASE_SCREEN_ROUTE,
        icon: <OrderPurchaseIcon />,
        title: "Order Purchase",
      },

      {
        id: 9,
        href: MEDICINES_DASHBOARD_SCREEN_ROUTE,
        icon: <MedicalProductsIcon />,
        title: "Medical Products",
      },
      {
        id: 10,
        href: NONMEDICINES_DASHBOARD_SCREEN_ROUTE,
        icon: <MedicalProductsIcon />,
        title: "Non Medical Products",
      },
      {
        id: 11,
        href: SUPPLIER_DASHBOARD_SCREEN_ROUTE,
        icon: <SupplierIcon />,
        title: "Supplier",
      },
      {
        id: 12,
        href: CATEGORY_DASHBOARD_SCREEN_ROUTE,
        icon: <CategoryIcon />,
        title: "Category",
      },
      {
        id: 13,
        href: MEDICINEFORMULA_DASHBOARD_SCREEN_ROUTE,
        icon: <MedicineFormulaIcon />,
        title: "Medicine Formula",
      },
      {
        id: 14,
        href: MANUFACTURER_DASHBOARD_SCREEN_ROUTE,
        icon: <ManufacturerIcon />,
        title: "Manufacturer",
      },
      {
        id: 15,
        href: PURCHASES_DASHBOARD_SCREEN_ROUTE,
        icon: <StockPurchaseIcon />,
        title: "Stock Purchase",
      },
      {
        id: 16,
        href: SHELF_DASHBOARD_SCREEN_ROUTE,
        icon: <ShelfIcon />,
        title: "Shelf",
      },
    ],
  },
  {
    id: 9,
    href: STAFFMANAGEMENT_DASHBOARD_SCREEN_ROUTE,
    icon: <StaffmanagementIcon />,
    title: "Staff Management",
  },

  {
    id: 10,
    href: SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE,
    icon: <ShiftManagementIcon />,
    title: "Shift Management",
  },
  

  {
    id: 17,
    icon: <DailyExpenseIcon/>,
    title: "Daily Expense",
    icon2: <ArrowUpIcon />,
    icon3: <ArrowDownIcon />,
    subItems: [
      {
        id: 18,
        href: EXPENSE_SCREEN_ROUTE,
        icon: <ExpenseIcon/>,
        title: "Expense",
      },
      {
        id: 19,
        href: EXPENSE_CATEGORY_SCREEN_ROUTE,
        icon: <ExpenseCategoryIcon/>,
        title: "Expense Category",
      },
    ]
  },
  {
    id: 11,
    icon: <UserManagementIcon />,
    title: "Settings",
    icon2: <ArrowUpIcon />,
    icon3: <ArrowDownIcon />,
    subItems: [
      {
        id: 14,
        href: CHANGE_PASSWORD_SCREEN_ROUTE,
        icon: <ChangePasswordIcon />,
        title: "Change Password",
      },
      {
        id: 15,
        href: RETURN_POLICY_SCREEN_ROUTE,
        icon: <ReturnPolicyIcon />,
        title: "Return Policy/Notes",
      },
      
    ]
  },


  // Add other sidebar items here
];

export const SidebarOtherItems = [
  {
    id: 1,
    href: GETTECHINAL_DASHBOARD_SCREEN_ROUTE,
    icon: <GetTechnicalIcon />,
    title: "Get Technical Help",
  },
];
export const ClinicCms = [
  {
    id: 1,
    //href: CLINIC_DASHBOARD_SCREEN_ROUTE,
    //href: "/cms/dashboard/dashboard-clinic",
    icon: <ClinicIcon />,
    title: "Open Clinic CMS",
  },

 
];

